// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"70":"file-xlsx","136":"tours","137":"file-pptx","288":"lottie","642":"file-pdf","712":"shared","972":"file-docx"}[chunkId] || chunkId) + "." + {"70":"baf70f07","136":"1a5ac57e","137":"22e05043","288":"78d9111b","291":"de26662f","642":"70efbb43","712":"d19762f9","811":"f647abbe","972":"a1169bfa"}[chunkId] + ".js";
};